const DEFAULT_LOCAL_ADMIN_API_URL = 'http://localhost:3010/api';

const normalizeBaseUrl = (value: string): string => value.replace(/\/$/, '');

export const getAdminApiBaseUrl = (): string => {
  const configured = (process.env.REACT_APP_ADMIN_API_URL || '').trim();
  if (configured && configured !== 'undefined') {
    return normalizeBaseUrl(configured);
  }

  const adminPortalUrl = (process.env.REACT_APP_ADMIN_URL || '').trim();
  if (adminPortalUrl && adminPortalUrl !== 'undefined') {
    return `${normalizeBaseUrl(adminPortalUrl)}/api`;
  }

  return DEFAULT_LOCAL_ADMIN_API_URL;
};
